// The 11 launch certifications — content matches the brief verbatim.
// Channels values: "school" | "college" | "corporate" | "individual"
// Tier values: "AI Native" | "AI Builder" | "AI Leader"

export const CERTIFICATIONS = [
  {
    sku: "AIE-NAT-001",
    title: "AI Essentials",
    pillar: "P01 — AI Foundations",
    tiers: ["AI Native"],
    hours: "8 hrs",
    audience: "Everyone's first step into AI — students, parents, professionals.",
    outcome:
      "Use ChatGPT, Claude, and Gemini effectively. Write structured prompts. Build a personal Custom GPT.",
    capstone:
      "1 deployed Custom GPT project + your personal prompting toolkit.",
    channels: ["school", "college", "corporate", "individual"],
  },
  {
    sku: "AIE-NAT-002",
    title: "AI for Everyone",
    pillar: "P01 — AI Foundations",
    tiers: ["AI Native"],
    hours: "8 hrs",
    audience: "AI literacy for working professionals across any role.",
    outcome:
      "Apply AI to daily work tasks. Identify role-specific AI workflows. Speak AI fluently with colleagues.",
    capstone: "1 'AI in My Job' workflow map + 3 implemented use cases.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-BLD-003",
    title: "AI Vibe Coder",
    pillar: "P02 — AI Builders",
    tiers: ["AI Builder"],
    hours: "40 hrs +10",
    audience: "Build real apps and websites without being a coder.",
    outcome:
      "Build a deployed web app with AI assistance. Use vibe coding tools. Deploy to production.",
    capstone: "3 deployed live web apps with GitHub repos and public URLs.",
    channels: ["college", "individual"],
  },
  {
    sku: "AIE-LDR-004",
    title: "Chief AI Officer",
    pillar: "P05 — AI Leadership",
    tiers: ["AI Leader"],
    hours: "110 hrs +20",
    audience:
      "Senior leaders, CXOs, transformation heads. Become the AI leader your company needs.",
    outcome:
      "Architect enterprise AI strategy. Govern AI risk and ethics. Lead AI transformation. Present to boards.",
    capstone:
      "Full AI transformation blueprint for your organization + governance framework + boardroom-ready strategy memo.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-FIN-005",
    title: "AI for Finance",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder", "AI Leader"],
    hours: "40 / 110 hrs",
    audience: "For CAs, CMAs, CFOs, finance teams, and finance professionals.",
    outcome:
      "Automate financial workflows. Build AI-driven analysis dashboards. Lead AI transformation in finance.",
    capstone:
      "Deployed finance automation system + AI-powered analysis dashboard + transformation blueprint.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-MED-006",
    title: "AI for Doctors",
    pillar: "P04 — AI for Industry",
    tiers: ["AI Builder", "AI Leader"],
    hours: "40 / 110 hrs",
    audience: "Physicians, surgeons, residents, hospital administrators.",
    outcome:
      "Use AI for clinical research, documentation, imaging, triage, and decision support — with safety frameworks.",
    capstone:
      "Clinical AI workflow suite + patient communication automation + governance and safety framework.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-LAW-007",
    title: "AI for Lawyers",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder", "AI Leader"],
    hours: "40 / 110 hrs",
    audience: "Lawyers, legal teams, GCs, paralegals, law firm partners.",
    outcome:
      "Draft contracts and briefs with AI. Run case research. Build due diligence automation. Govern ethics.",
    capstone:
      "Practice automation suite (drafting, research, review) + ethics and confidentiality framework.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-SAL-008",
    title: "AI for Sales",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder"],
    hours: "40 hrs",
    audience:
      "Sales reps, SDRs, AEs, sales managers. Close more, faster.",
    outcome:
      "Build AI prospecting workflows. Run AI-powered discovery calls. Build sales playbooks with AI.",
    capstone:
      "Personalized AI outreach engine + 90-day sales automation playbook.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-MKT-009",
    title: "AI for Marketing",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder"],
    hours: "40 hrs",
    audience: "Brand, content, and growth marketers. From ideation to campaigns.",
    outcome:
      "Build content engines (text, image, video). Run AI-augmented campaigns. Build a marketing OS.",
    capstone: "Brand content engine + 30-day campaign + measurement dashboard.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-PRF-010",
    title: "AI for Performance & Digital Marketing",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder"],
    hours: "40 hrs",
    audience:
      "Performance marketers, growth leads, paid media specialists, agency teams.",
    outcome:
      "Run AI-optimized paid campaigns. Build creative production engines. Automate reporting and attribution.",
    capstone:
      "Live AI-driven campaign with attribution dashboard + creative production engine.",
    channels: ["corporate", "individual"],
  },
  {
    sku: "AIE-HR-011",
    title: "AI for HR",
    pillar: "P03 — AI at Work",
    tiers: ["AI Builder"],
    hours: "40 hrs",
    audience: "HR business partners, talent acquisition, L&D, people ops.",
    outcome:
      "Build AI screening workflows. Design AI-driven L&D paths. Govern AI in HR ethically.",
    capstone: "End-to-end recruitment automation + L&D personalization engine.",
    channels: ["corporate", "individual"],
  },
];

export const CHANNEL_LABEL = {
  school: "School",
  college: "College",
  corporate: "Corporate",
  individual: "Individual",
};
